import {
  BOUNDARY_CREATE_WMS_OPTIMIZED_ADD_ITEM,
  BOUNDARY_CREATE_WMS_OPTIMIZED_REMOVE_ITEM, BOUNDARY_CREATE_WMS_OPTIMIZED_UPDATE_ITEM,
} from './boundaryCreateWMSOptimized.actionTypes';
import { type BoundaryCreateWMSOptimizedItem } from './boundaryCreateWMSOptimized.state';

export const boundaryCreateWMSOptimizedAddItem = (item: BoundaryCreateWMSOptimizedItem) => ({
  type: BOUNDARY_CREATE_WMS_OPTIMIZED_ADD_ITEM,
  payload: {
    item,
  },
}) as const;

export const boundaryCreateWMSOptimizedUpdateItem = (updatedItem: Omit<BoundaryCreateWMSOptimizedItem, 'startedOnCurrentTab'>) => ({
  type: BOUNDARY_CREATE_WMS_OPTIMIZED_UPDATE_ITEM,
  payload: {
    updatedItem,
  },
}) as const;

export const boundaryCreateWMSOptimizedRemoveItem = (id: number) => ({
  type: BOUNDARY_CREATE_WMS_OPTIMIZED_REMOVE_ITEM,
  payload: {
    id,
  },
}) as const;
